// src/index.ts
export { PhoneInputWithCountrySelectList } from "./components/PhoneInputWithCountrySelectList";

// Import CSS automatically
import "./styles/global-css-imports";

// Export a function to manually import CSS if needed
export const importStyles = () => {
  if (typeof window !== 'undefined') {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://unpkg.com/phonix-input@1.0.10/dist/index.css';
    document.head.appendChild(link);
  }
};
